import React from "react";
import { Button, Form } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import "./InputGroupstyle.css";

export const AutoCompleteValue = "off"; //new-password for chrome
const InputGroupForm = ({
  value,
  placeholder,
  isDisabled = false,
  textArea = false,
  onChange = null,
  onClick = null,
  rows = 2,
  type = "text",
  maxlength = null,
  alignment = "right",
  ButtonName = "",
  ...rest
}) => {
  return (
    <>
    <InputGroup className="mb-3">
      {alignment == "left" && (
        <Button disabled={isDisabled} variant="outline-secondary" className="saveBtn" id="button-addon1" onClick={onClick}>
          {ButtonName}
        </Button>
      )}
      {textArea ? (
        <Form.Control
          placeholder={placeholder}
          value={value ?? ""}
          disabled={isDisabled}
          onChange={onChange}
          as="textarea"
          rows={rows}
          type={type}
          maxLength={maxlength}
          {...rest}
        />
      ) : (
        <Form.Control
          placeholder={placeholder}
          value={value ?? ""}
          autoComplete={AutoCompleteValue}
          disabled={isDisabled}
          onChange={onChange}
          type={type}
          maxLength={maxlength}
          {...rest}
        />
      )}
      {alignment == "right" && (
        <Button disabled={isDisabled} variant="outline-secondary" className="saveBtn" id="button-addon1" onClick={onClick}>
          {ButtonName}
        </Button>
      )}
      </InputGroup>
    </>
  );
};

export default InputGroupForm;
